module.exports = __webpack_public_path__ + "static/media/youtube.0f519090.svg";